import React, { useContext } from 'react';
import DwellingCard from './DwellingCard';
import Pagination from './Pagination';
import Translation from '../../../../Shared/components/Translation';
import { UnitContext } from '../../../context/UnitContext';
import UrlService from '../../../services/UrlService';
import ComplexCard from './ComplexCard';
const ListView = ({ units }) => {
    const { state } = useContext(UnitContext);
    const hasFilters = state.filters[state.currentFilterGroup].userFilters.length;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "zds-headline-sm zds-margin-bottom-6" },
            state.totalUnits.toLocaleString(document.documentElement.lang),
            state.totalUnits >= 10000 ? '+ ' : ' ',
            state.totalUnits === 1 ? (React.createElement(Translation, { item: 'tx_zigrealestate.search.search_counter_result' })) : (React.createElement(Translation, { item: 'tx_zigrealestate.search.search_counter_results' }))),
        React.createElement("div", { className: state.currentView === 'tiles'
                ? `zds-grid lg:zds-grid-cols-3 zds-grid-cols-1 sm:zds-grid-cols-2 ${hasFilters ? 'zds-gap-4' : 'zds-gap-6'}`
                : '' }, state.currentFilterGroup === 'complex'
            ? units.map((unit) => (React.createElement(ComplexCard, { key: unit._id, complex: unit._source.fields, url: UrlService.getAbsoluteUrlForPathSegment(unit._source.url), currentView: state.currentView })))
            : units.map((unit) => (React.createElement(DwellingCard, { key: unit._id, unit: unit._source.fields, url: UrlService.getAbsoluteUrlForPathSegment(unit._source.url), currentView: state.currentView, bodyPadded: true })))),
        React.createElement(Pagination, null)));
};
export default ListView;
